export default "__VITE_ASSET__Oz6PgxGE__"